import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TaskItemStatus } from '@r1-development/resolution-mechanicalturk-api-client';
import { SidebarTaskGroupUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';
import { PhoneNumberPipe } from 'src/app/routes/tasks-worker/renderers/completed-task-type/shared/pipes/phone-number.pipe';

@Component({
  selector: 'ri-resolution-ui-call-payer-group-template',
  templateUrl: './call-payer-group-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PhoneNumberPipe],
})
export class CallPayerGroupTemplateComponent {
  readonly group = input.required<SidebarTaskGroupUi>();
  readonly taskItemStatus = TaskItemStatus;
}
